module.exports = __webpack_public_path__ + "static/img/索尼（Sony） XR90.67665aed.png";